import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import QRCode from "react-qr-code";
import { toast } from "react-toastify";
import io from "socket.io-client";
import { set } from "lodash";
import atmoLogo2 from "../../assets/images/atmo logo.png";
import { Link } from "react-router-dom";

const socketUrl = "https://api-kitchen.atmodigital.tech";

const AgendamentoScreen = () => {
  const [refeicoes, setRefeicoes] = useState([]);
  const [reservasPorHora, setReservasPorHora] = useState({});
  const [userScheduling, setUserScheduling] = useState(null);
  const [showQrCode, setShowQrCode] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [token, setToken] = useState(Cookies.get("auth_token") || "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(!token);

  const kitchenUrl = process.env.REACT_APP_KITCHEN_URL;
  console.log("Kitchen URL:", kitchenUrl);
  const checkInUrl = `${kitchenUrl}/checkin/`;
  const socketRef = useRef(null);

  useEffect(() => {
    if (token) {
      socketRef.current = io(socketUrl, { transports: ["websocket"] });

      const socket = socketRef.current;
      socket.on("connect", () => console.log("Socket conectado"));
      socket.on("atualizarReservas", (novasReservas) =>
        setReservasPorHora(novasReservas)
      );

      return () => {
        socket.disconnect();
      };
    }
  }, [token]);

  const login = async () => {
    try {
      const res = await axios.post(`${kitchenUrl}/api/auth/issue-token`, {
        email,
        password,
      });
      const newToken = res.data.token;
      Cookies.set("auth_token", newToken);
      setToken(newToken);
      setShowLogin(false);
      await loadData(newToken);
    } catch {
      toast.error("E-mail ou senha incorretos");
    }
  };

  useEffect(() => {
    const init = async () => {
      console.log(token);
      if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        setToken(token);
        await fetchRefeicoes(token);
        await fetchUserScheduling(token);
        await getAvailablePositions(token);
      } else {
        setShowLogin(true);
      }
    };

    init();
  }, []);

  const loadData = async (token) => {
    await Promise.all([fetchRefeicoes(token), fetchUserScheduling(token)]);
    setLoading(false);
  };

  const fetchRefeicoes = async (token) => {
    const res = await axios.post(
      `${kitchenUrl}/api/agendamentos/horarios-disponiveis`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setRefeicoes(res.data.refeicoes);
    const reservas = {};
    res.data.refeicoes.forEach((item) => {
      reservas[item.hora_inicio] = item.posicoes;
    });
    setReservasPorHora(reservas);
    setLoading(false);
  };

  const fetchUserScheduling = async (token) => {
    const res = await axios.post(
      `${kitchenUrl}/api/agendamentos/get_user_scheduling`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setUserScheduling(res.data.agendamento_usuario);
  };

  const confirmAgendamento = async (item) => {
    try {
      const res = await axios.post(
        `${kitchenUrl}/api/agendamentos/storeApi`,
        {
          id_refeicao: item.id,
          id_horario_refeicao: item.id_horario_refeicao,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      socketRef.current.emit("reservaFeita", {
        hora_inicio: item.hora_inicio,
        reservasPorHora,
      });
      setUserScheduling(res.data.agendamento_usuario);
      setQrCodeUrl(`${checkInUrl}${res.data.agendamento_usuario.id}`);
      setShowQrCode(true);
      toast.success("Reserva feita com sucesso");
      await fetchRefeicoes(token);
    } catch (err) {
      toast.error(err.response?.data?.error || "Erro ao reservar");
    }
  };

  const destroyAgendamento = async (item) => {
    try {
      await axios.delete(`${kitchenUrl}/api/agendamentos/destroy`, {
        data: {
          id_refeicao: item.id,
          id_horario_refeicao: item.id_horario_refeicao,
        },
        headers: { Authorization: `Bearer ${token}` },
      });
      socketRef.current.emit("reservaExcluida", {
        hora_inicio: item.hora_inicio,
        reservasPorHora,
      });
      setUserScheduling(null);
      toast.success("Reserva cancelada com sucesso");
      await fetchRefeicoes(token);
    } catch {
      toast.error("Erro ao cancelar");
    }
  };

  const getAvailablePositions = async () => {
    try {
      if (refeicoes.length > 0) {
        const response = await axios.post(
          `${kitchenUrl}/api/agendamentos/get_available_positions/${refeicoes[0]?.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
        setReservasPorHora(response.data.posicoes);
      }
    } catch (error) {
      console.error("Erro ao buscar as posições por horário:", error);
    }
  };

  if (showLogin) {
    return (
      <div id="content-page" className="content-inner">
        <Container className="mt-5">
          <Card className="p-4 col-md-6 mx-auto">
            <div className="sign-in-from text-center">
              <img
                style={{ width: "250px" }}
                src={atmoLogo2}
                className="img-fluid mb-2"
                alt="images"
              />
              <h3>Login Atmo Kitchen</h3>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                />
              </Form.Group>
              <Button onClick={login}>Entrar</Button>
            </div>
          </Card>
        </Container>
      </div>
    );
  }

  if (loading) return <Spinner className="d-block mx-auto mt-5" />;

  return (
    <div id="content-page" className="content-inner">
      <Container className="mt-4">
        <Row>
          <Col sm="12">
            <Card className="position-relative inner-page-bg bg-primary p-5">
              <div
                className="inner-page-title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                }}
              >
                <h3 className="text-white">Atmo Kitchen</h3>
                <Link to="/" className="text-white py-1 px-2">
                  <i className="icon material-symbols-outlined d-flex">
                    arrow_back
                  </i>
                </Link>
              </div>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Body>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Horário</th>
                      <th>Prato</th>
                      <th>Sobremesa</th>
                      <th>Posições</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {refeicoes.map((item) => {
                      const isReservado =
                        userScheduling?.id_horario_refeicao ===
                        item.id_horario_refeicao;
                      const isDisabled =
                        !!userScheduling ||
                        reservasPorHora[item.hora_inicio] <= 0;
                      return (
                        <tr key={item.id_horario_refeicao}>
                          <td>{item.hora_inicio}</td>
                          <td>{item.prato_principal}</td>
                          <td>{item.sobremesa}</td>
                          <td>{reservasPorHora[item.hora_inicio] ?? 0}</td>
                          <td>
                            {isReservado ? (
                              <>
                                <Button
                                  variant="success"
                                  onClick={() => {
                                    setQrCodeUrl(
                                      `${checkInUrl}${userScheduling.id}`
                                    );
                                    setShowQrCode(true);
                                  }}
                                >
                                  QR Code
                                </Button>{" "}
                                <Button
                                  variant="danger"
                                  onClick={() => destroyAgendamento(item)}
                                >
                                  Cancelar
                                </Button>
                              </>
                            ) : (
                              <Button
                                disabled={isDisabled}
                                onClick={() => confirmAgendamento(item)}
                              >
                                Reservar
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal show={showQrCode} onHide={() => setShowQrCode(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>QR Code para Check-in</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <QRCode value={qrCodeUrl} size={256} />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowQrCode(false)}>Fechar</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default AgendamentoScreen;
